import storages from '../../api/storages'

export default {
    namespaced: true,
    state: () => ({
        loading: false,
        items: []
    }),
    getters: {},
    actions: {
        getStorages ({ commit }) {
            commit('setLoading', true)
            return storages.getStorages().then((response) => {
                commit('setItems', response.data.storages)
                commit('setLoading', false)
            })
        }
    },
    mutations: {
        setLoading (state, bool) {
            state.loading = bool
        },
        setItems (state, data) {
            state.items = data
        }
    }
}
